import React, { Fragment, useEffect, useState } from "react";
import { handleGetApiGF, rupeesFn, Toast } from "../Utils/general-function";

import NoCars from "../Utils/NoCars";
import Header from "../Header";
import Loader from "../Utils/Loader";

const RcSearchLog = () => {
  const [loader, setLoader] = useState(true);
  const [logs, setLogs] = useState([]);

  const fetchLogs = async () => {
    let obj = new URLSearchParams({
      Pageindex: 1,
      time: Date.now(),
    });
    const res = await handleGetApiGF({
      url: "/api/WalletTransaction/DealerWalletTransactionlog?" + obj,
    });
    setLoader(false);
    if (!res?.succ) {
      Toast(false, "", res?.msg || "Failed to fetch logs");
      return;
    }

    setLogs(res?.data?.Data || []);
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <div>
      <Header />
      {loader && <Loader />}
      <div className="text-center">
        <h2 className="page-title">RC Search Logs</h2>
      </div>
      <div className="txn-container page-space">
        <h5 className="mb-0">
          Total Searches : <b className="text-danger">{logs?.length}</b>
        </h5>
        {logs.length > 0 ? (
          logs.map((item) => (
            <Fragment key={item?.Id}>
              <div className="txn-card">
                {/* LEFT ICON */}
                <div className="txn-icon">
                  <span className="material-symbols-outlined fw-4 text-danger">
                    directions_car
                  </span>
                </div>

                <div className="txn-content">
                  {/* TOP */}
                  <div className="txn-top">
                    <div>
                      {" "}
                      <h3 className="mb-0">{item?.Vehicalno}</h3>
                      <span>
                        {new Date(item?.dCreateDate).toLocaleString("en-IN")}
                      </span>
                    </div>
                    <div>
                      <span className={`txn-amount text-danger`}>
                        {rupeesFn(item?.ServicesPrice)}
                      </span>
                      <p className={` mb-0 text-danger`}>
                        {item?.nTransactionType}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Fragment>
          ))
        ) : (
          <NoCars img="" mainMsg="No Logs Found" msg="" />
        )}
      </div>
    </div>
  );
};

export default RcSearchLog;
